import { Box, Button, Flex, Heading, Separator, Skeleton, Text } from '@radix-ui/themes';

export const SkeletonCategory = () => (
  <Box mb="5">
    <Skeleton className="skeleton-category-title" />
    <Box mt="4">
      {[0, 1].map((idx) => (
        <Skeleton key={idx} className="skeleton-category-row" />
      ))}
    </Box>
    <Separator size="4" className="skeleton-separator" />
  </Box>
);

type CardEmptyStateProps = {
  hasCountry: boolean;
};

export const CardEmptyState = ({ hasCountry }: CardEmptyStateProps) => (
  <Box
    mt="4"
    py="6"
    px="5"
    className="empty-card"
  >
    <Heading size="4" mb="2">
      {hasCountry ? 'No audiences available' : 'Choose a country to get started'}
    </Heading>
    <Text color="gray">
      {hasCountry
        ? 'We could not find any audiences for the selected country. Try switching to a different market or platform.'
        : 'Select a country from the dropdown to load audience categories and see how they are described.'}
    </Text>
  </Box>
);

type CategoryEmptyStateProps = {
  categoryName: string;
  onClear: () => void;
};

export const CategoryEmptyState = ({ categoryName, onClear }: CategoryEmptyStateProps) => (
  <Box
    mt="4"
    py="6"
    px="5"
    className="empty-card"
  >
    <Heading size="4" mb="2">
      No audiences available in {categoryName}
    </Heading>
    <Flex align="center" gap="3">
      <Text color="gray">
        Try another category or return to the full catalogue.
      </Text>
      <Button variant="soft" color="gray" onClick={onClear}>
        Clear
      </Button>
    </Flex>
  </Box>
);

export const SearchEmptyState = () => (
  <Box
    mt="4"
    py="5"
    px="5"
    className="empty-card"
  >
    <Heading size="4" mb="2">
      No audiences match your search
    </Heading>
    <Text color="gray">
      Try another keyword or clear the search box to browse all categories again.
    </Text>
  </Box>
);
